import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const GetConsumeFleet = createAsyncThunk(
    'partsales/consumefleet',
    async()=>{
        const response = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/api/consumefleet`
        ).catch((err) => {
            return {'status': err.status, 'data': 'failed'}
        })
        return {'status': response.status, 'data': response.data }
    }
)

export const GetConsumeGroup = createAsyncThunk(
    'partsales/consumegroup',
    async()=>{
        const response = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/api/consumegroup` 
        ).catch((err) => {
            return {'status': err.status, 'data': 'failed'}
        })
        return {'status': response.status, 'data': response.data }
    }
)

export const GetConsumeFleetGroup = createAsyncThunk(
    'partsales/consumefleetgroup',
    async(params)=>{
        const response = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/api/consumefleetgroup`,
            params,
        ).catch((err) => {
            return {'status': err.status, 'data': 'failed'}
        })
        return {'status': response.status, 'data': response.data }
    }
)

export const getConsumable = createAsyncThunk(
    'partsales/consumable',
    async (params) => {
        const response = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/api/consume`,  
            params,
        ).catch((err) => {
            return {'status': err.status, 'data': 'failed'}
        })
        return {'status': response.status, 'data': response.data }
    }
)